import { render, staticRenderFns } from "./RightSideContents.vue?vue&type=template&id=08ec6047&"
import script from "./RightSideContents.vue?vue&type=script&lang=js&"
export * from "./RightSideContents.vue?vue&type=script&lang=js&"
import style0 from "./RightSideContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports